import { Controller } from '@hotwired/stimulus';

export default class SubscriptionStepsController extends Controller {
  static targets = [
    'subscriptionStep1Success',
    'subscriptionStep1Failure',
    'subscriptionStep2Success',
    'subscriptionStep2Error',
    'subscriptionStep3',
    'generatingDocIcon',
    'generatedDocIcon',
    'generatingDocExplanations',
    'generatingDocReady',
    'acceptDocCheckbox',
    'confirmSubscriptionButton',
  ];

  connect() {
    this.errorDelayTimeInMs = 5000;
    this.element.addEventListener(
      'signature:show-generating',
      this.handleShowGenerating.bind(this)
    );
    this.element.addEventListener(
      'signature:show-generated',
      this.handleShowGenerated.bind(this)
    );
    this.element.addEventListener(
      'signature:show-contract',
      this.handleShowContract.bind(this)
    );
    this.element.addEventListener(
      'signature:show-completion',
      this.handleShowCompletion.bind(this)
    );
    this.element.addEventListener(
      'signature:show-error',
      this.handleShowError.bind(this)
    );
    this.element.addEventListener(
      'signature:delay-expired',
      this.handleDelayExpired.bind(this)
    );
  }

  disconnect() {
    this.element.removeEventListener(
      'signature:show-generating',
      this.handleShowGenerating.bind(this)
    );
    this.element.removeEventListener(
      'signature:show-generated',
      this.handleShowGenerated.bind(this)
    );
    this.element.removeEventListener(
      'signature:show-contract',
      this.handleShowContract.bind(this)
    );
    this.element.removeEventListener(
      'signature:show-completion',
      this.handleShowCompletion.bind(this)
    );
    this.element.removeEventListener(
      'signature:show-error',
      this.handleShowError.bind(this)
    );
    this.element.removeEventListener(
      'signature:delay-expired',
      this.handleDelayExpired.bind(this)
    );
  }

  handleShowGenerating(event) {
    this.showGeneratingState();
  }

  handleShowGenerated(event) {
    this.showGeneratedState();
  }

  handleShowContract(event) {
    this.showContractState();
  }

  handleShowCompletion(event) {
    this.showCompletionState();
  }

  handleShowError(event) {
    const { delay = 5000 } = event.detail || {};
    this.showErrorState(delay);
  }

  handleDelayExpired(event) {
    this.lockBulletin();
  }

  showGeneratingState() {
    this.subscriptionStep1SuccessTarget.classList.remove('d-none');
    this.generatingDocIconTarget.classList.remove('d-none');
    this.generatedDocIconTarget.classList.add('d-none');
    this.generatingDocExplanationsTarget.classList.remove('d-none');
    this.generatingDocReadyTarget.classList.add('d-none');
  }

  showGeneratedState() {
    this.subscriptionStep1SuccessTarget.classList.remove('d-none');
    this.generatingDocIconTarget.classList.add('d-none');
    this.generatedDocIconTarget.classList.remove('d-none');
    this.generatingDocExplanationsTarget.classList.add('d-none');
    this.generatingDocReadyTarget.classList.remove('d-none');
  }

  showContractState() {
    this.subscriptionStep1SuccessTarget.classList.add('d-none');
    this.subscriptionStep2SuccessTarget.classList.remove('d-none');
  }

  showCompletionState() {
    this.subscriptionStep2SuccessTarget.classList.add('d-none');
    this.subscriptionStep3Target.classList.remove('d-none');
  }

  showErrorState() {
    setTimeout(() => {
      this.subscriptionStep1SuccessTarget.classList.add('d-none');
      this.subscriptionStep2SuccessTarget.classList.add('d-none');
      this.subscriptionStep3Target.classList.add('d-none');
      this.subscriptionStep2ErrorTarget.classList.remove('d-none');
    }, this.errorDelayTimeInMs);
  }

  lockBulletin() {
    this.acceptDocCheckboxTarget.checked = false;
    this.acceptDocCheckboxTarget.disabled = true;
    this.confirmSubscriptionButtonTarget.disabled = true;
  }
}
